export function gsConfirm(options) {
  const opt = options || {}
  const title = opt.title || '提示'
  const message = opt.message || ''
  const confirmText = opt.confirmButtonText || '确定'
  const cancelText = opt.cancelButtonText || '取消'
  return new Promise((resolve, reject) => {
    const mask = document.createElement('div')
    mask.className = 'gs-confirm-mask'
    mask.innerHTML = ''
      + '<div class="gs-confirm" role="dialog" aria-modal="true">'
      + '<div class="gs-confirm-title"></div>'
      + '<p class="gs-confirm-msg"></p>'
      + '<div class="gs-confirm-actions">'
      + '<button type="button" class="gs-confirm-btn" data-act="cancel"></button>'
      + '<button type="button" class="gs-confirm-btn is-primary" data-act="ok"></button>'
      + '</div></div>'
    mask.querySelector('.gs-confirm-title').textContent = title
    mask.querySelector('.gs-confirm-msg').textContent = message
    mask.querySelector('[data-act="cancel"]').textContent = cancelText
    mask.querySelector('[data-act="ok"]').textContent = confirmText
    let closed = false
    const done = (ok) => {
      if (closed) return
      closed = true
      document.removeEventListener('keydown', onKey)
      if (mask.parentNode) mask.parentNode.removeChild(mask)
      if (ok) resolve(true)
      else reject(new Error('cancel'))
    }
    const onKey = (event) => {
      if (event.key === 'Escape') done(false)
      if (event.key === 'Enter') done(true)
    }
    mask.addEventListener('mousedown', (event) => {
      if (event.target === mask) done(false)
    })
    mask.addEventListener('click', (event) => {
      const act = event.target && event.target.getAttribute && event.target.getAttribute('data-act')
      if (act === 'ok') done(true)
      if (act === 'cancel') done(false)
    })
    document.addEventListener('keydown', onKey)
    document.body.appendChild(mask)
  })
}
